export const dealLottiePath = (path: string): string => {
  const env = process.env.VUE_APP_PREPATH;
  if (env === "test") {
    return "/ibook" + path;
  }
  if (env === "production") {
    return "https://sites.xueersibook.com/h5-ibook/" + path;
  }
  return path;
};
